import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'crypto-reset-password-message',
  templateUrl: './reset-password-message-crypto.component.html',
  styleUrls: [ './reset-password-message-crypto.component.scss' ],
})
export class ResetPasswordMessageCryptoComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages-crypto/components-crypto/reset-password-message-crypto/reset-password-message-crypto.component.ts